(function () {
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scrollOptions = { behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' };

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', event => {
      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;
      const target = document.querySelector(href);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView(scrollOptions);
    });
  });

  const modal = document.getElementById('licenseTermsModal');
  const title = document.getElementById('licenseTermsTitle');
  const eyebrow = document.getElementById('licenseTermsEyebrow');
  const body = document.getElementById('licenseTermsBody');

  const terms = {
    lease: {
      title: 'Basic Lease — License Agreement',
      eyebrow: 'License Terms · Tier 1',
      template: 'licenseTermsLease'
    },
    premium: {
      title: 'Premium Lease — License Agreement',
      eyebrow: 'License Terms · Tier 2',
      template: 'licenseTermsPremium'
    },
    exclusive: {
      title: 'Exclusive — License Agreement',
      eyebrow: 'License Terms · Tier 3',
      template: 'licenseTermsExclusive'
    }
  };

  function openLicenseTerms(key) {
    const data = terms[key];
    if (!modal || !data) return;
    const template = document.getElementById(data.template);
    if (title) title.textContent = data.title;
    if (eyebrow) eyebrow.textContent = data.eyebrow;
    if (body) {
      body.innerHTML = template ? template.innerHTML : '<p>License terms have not been configured yet.</p>';
      body.scrollTop = 0;
    }
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('v3-modal-lock');
  }

  function closeLicenseTerms() {
    if (!modal) return;
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('v3-modal-lock');
  }

  document.querySelectorAll('[data-license-modal-open]').forEach(trigger => {
    trigger.addEventListener('click', event => {
      event.preventDefault();
      openLicenseTerms(trigger.dataset.licenseModalOpen);
    });
  });

  document.querySelectorAll('[data-license-modal-close]').forEach(trigger => {
    trigger.addEventListener('click', closeLicenseTerms);
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && modal?.classList.contains('open')) closeLicenseTerms();
  });
})();
